import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Restricts a route to users with `is_admin = true`. Anonymous users go to
 * /login (preserves intended destination); non-admin authed users are routed
 * to /account as required by the spec.
 */
export default function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div
        data-testid="admin-route-loading"
        className="min-h-[60vh] flex items-center justify-center text-charcoal-400 text-sm"
      >
        Verifying admin session…
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: "/admin" }} />;
  if (!user?.is_admin) return <Navigate to="/account" replace />;
  return children;
}
